
export default {
  SET_REPORT_ID (state, data) {
    state.reportId = data;
  },

  SET_VERSION_ID (state, data) {
    state.versionId = data;
  },

  SET_VESSEL_DETAIL(state, data) {
    state.vesselDetail = data;
  },

  SET_VERSION(state, data) {
    state.version = data;
  },

  SET_CREATED (state, data) {
    state.created = data;
  },

  SET_UPDATED (state, data) {
    state.updated = data;
  },

  SET_SENDER (state, data) {
    state.sender = data;
  },

  SET_REPORT_ITEMS (state, data) {
    state.reportItems = data;
  },

  SET_WORK_FLOW_STATUS (state, data) {
    state.workflowStatus = data;
  },

  SET_HISTORIES (state, data) {
    state.histories = data;
  },

  SET_DETAIL (state, data) {
    state.reportDetail = data;
  },

  SET_GROUPED_HISTORIES(state, data) {
    state.groupedHistories= data;
  },

  RESET_STATE (state, data) {
    Object.assign(state, data)
  },
}
